import Product from "./product";

/** True if the feed item has product price fields (product item); false for banner/promo items. */
export function isProductItem(item: { [x: string]: any }): boolean {
  return (
    item != null &&
    (typeof item.best_buy_price === "number" ||
      typeof item.best_buy_price_string === "string")
  );
}

/** Normalize feed item to Product constructor shape (id → product_id, master_image → poster, label → button_discount_text). */
export function normalizeProductItem(item: { [x: string]: any }): { [x: string]: any } {
  return {
    ...item,
    product_id: item.product_id ?? item.id,
    poster: item.poster ?? item.master_image,
    button_discount_text: item.button_discount_text ?? item.label ?? undefined,
  };
}

/** Resolve feed rail id from common API field names (feed/list rails vary by backend). */
export function pickFeedId(data: { [x: string]: any }): number | string | undefined {
  const candidates = [
    data.feed_id,
    data.id,
    data.feedId,
    data.rail_id,
    data.railId,
    data.content_feed_id,
  ];
  for (const v of candidates) {
    if (v === undefined || v === null) continue;
    const s = String(v).trim();
    if (s === "" || s === "undefined" || s === "null") continue;
    return typeof v === "number" ? v : s;
  }
  return undefined;
}

/** `/collection/:id` when the rail has a usable id (includes numeric 0). */
export function getFeedCollectionExplorePath(feed: Feed): string | undefined {
  const raw = feed.id;
  if (raw === undefined || raw === null) return undefined;
  const s = String(raw).trim();
  if (s === "" || s === "undefined" || s === "null") return undefined;
  return `/collection/${encodeURIComponent(s)}`;
}

/** Explore All target only when `expandable` is true and a collection id exists. */
export function getFeedExploreAllPath(feed: Feed): string | undefined {
  if (!feed.expandable) return undefined;
  return getFeedCollectionExplorePath(feed);
}

export default class Feed {
  readonly id: number | string | undefined;
  readonly title: string;
  readonly items: Product[];
  readonly bannerItems: { [x: string]: any }[];
  readonly type: string;
  readonly expandable: boolean;

  constructor(data: { [x: string]: any }) {
    this.id = pickFeedId(data);
    this.title = data.title ?? "";
    this.type = data.type ?? "portrait_card";
    this.expandable = data.expandable === true;

    const rawItems = Array.isArray(data.items) ? data.items : [];
    this.items = rawItems
      .filter(isProductItem)
      .map((item: { [x: string]: any }) => new Product(normalizeProductItem(item)));
    this.bannerItems = rawItems.filter(
      (item: { [x: string]: any }) => !isProductItem(item)
    );
  }
}
